export default __webpack_public_path__ + "img/b678ab55cddb6f582a8b6297092136fe.png";